var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"payment-method-fade","mode":"out-in"}},[_c('KeepAlive',[_c(_vm.currentStep,{tag:"component",on:{"handleChangeStep":_vm.handleChangeStep,"closePopup":function($event){return _vm.$emit('closePopup')}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }